import { Source } from "src/redux/slices/contacts/lead";
import { CommonPagination } from "src/types/api/common";
import { Lead } from "src/types/api/ticket";
import request from "src/utils/request";

export type GetLeadRequestParams = {
    email?: string;
    keyword?: string | null;
    location_id?: number;
    procedure_id?: number;
    staff_id?: number;
    created_from?: number;
    created_to?: number;
    source?: string | null;
    stage?: string | null;
    limit?: number;
    page?: number;
};

export type GetLeadRequestParamsBySelectAndGroupBy = {
    groupBy: string;
    select: string;
    source?: string;
    stage?: string;
};

export type CreateLeadForm = {
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    staff_id?: number | null;
    procedures_interested_in?: string[];
    addons_interested_in?: string[];
};

export type UpdateLeadForm = {
    first_name?: string | null;
    last_name?: string | null;
    email?: string;
    phone?: string;
    date_of_birth?: string | null;
    email_optout?: boolean;
    sms_optin?: boolean;
    source?: string | null;
    gender?: string;
    staff_id?: number | null;
    medical_condition?: string;
    smoker?: boolean;
    weight?: number | null;
    height_feet?: number | null;
    stage?: string;
    height_inch?: number | null;
    address1?: string;
    address2?: string;
    procedures_interested_in?: string[];
    addons_interested_in?: string[];
};

export const deleteLeadApi = (id: number): Promise<unknown> =>
    request.delete(`api/leads/${id}`);

export const deleteContactsApi = (payload: {
    ids: number[];
}): Promise<unknown> =>
    request.delete(`api/leads/bulk/delete`, { data: payload });

export const getLeadsApi = (
    params: {
        [key: string]: string | number;
    } | null = null
): Promise<CommonPagination<Lead>> =>
    request.get<CommonPagination<Lead>, CommonPagination<Lead>>("/api/leads", {
        params,
    });

export const getAllLeadsApi = (params: {
    select_all?: boolean;
    select?: string | null;
}): Promise<CommonPagination<Lead>> =>
    request.get<CommonPagination<Lead>, CommonPagination<Lead>>("/api/leads", {
        params,
    });

export const getLeadApi = (id: number): Promise<Lead> =>
    request.get<Lead, Lead>(`api/leads/${id}`);

export const getLeadApiBySelectAndGroupBy = (
    params: GetLeadRequestParamsBySelectAndGroupBy | null = null
): Promise<Source> =>
    request.get<Source, Source>(`api/leads`, {
        params,
    });

export const createLeadApi = (form: CreateLeadForm): Promise<Lead> =>
    request.post<Lead, Lead>(`/api/leads`, form);

export const updateLeadApi = (
    id: number,
    form: UpdateLeadForm
): Promise<Lead> => request.post<Lead, Lead>(`/api/leads/${id}`, form);

export const checkLeadApi = (params: {
    keyword: string | undefined;
}): Promise<CommonPagination<Lead>> =>
    request.get<CommonPagination<Lead>, CommonPagination<Lead>>("/api/leads", {
        params,
    });
